import { useMemo, useCallback } from 'react';

const useGoodOption = ({
  isGroup,
  goodDetail,
  subGoodDetail,
  goodOptionList,
  setGoodOptionList,
  optionDropdownValidator,
}) => {
  const selectedGoodDetail = useMemo(
    () => (isGroup ? subGoodDetail : goodDetail),
    [goodDetail, isGroup, subGoodDetail]
  );

  const sortedSelectedOptionList = useMemo(() => {
    return [...goodOptionList].sort((a, b) =>
      a.subGoodIndex.localeCompare(b.subGoodIndex, undefined, { numeric: true, sensitivity: 'base' })
    );
  }, [goodOptionList]);

  const additionItemList = useMemo(
    () =>
      selectedGoodDetail?.additionItemList?.map?.((item) => ({
        ...item,
        itemKey: item.itemNumber,
        leafItem: { ...item, discountPrice: item.salePrice, discountFormattedPrice: item.saleFormattedPrice },
      })),
    [selectedGoodDetail?.additionItemList]
  );

  const handleDropDownOption = useCallback(
    ({ itemName, ...option }) => {
      if (optionDropdownValidator(option, selectedGoodDetail, goodOptionList)) {
        setGoodOptionList((prevOptions) => [
          ...prevOptions,
          {
            ...option,
            subGoodIndex: selectedGoodDetail?.subGoodIndex || '',
            itemName: selectedGoodDetail?.label ? `${selectedGoodDetail?.label} / ${itemName}` : itemName,
            stockManagement: selectedGoodDetail?.stockManagement,
            ordPossibleMinQty: selectedGoodDetail?.ordPossibleMinQty,
            ordPossibleMinAmount: selectedGoodDetail?.ordPossibleMinAmount,
            ordPossibleMaxQty: selectedGoodDetail?.ordPossibleMaxQty,
            ordPossibleMaxAmount: selectedGoodDetail?.ordPossibleMaxAmount,
            ordPossibleMaxQtyStandardCode: selectedGoodDetail?.ordPossibleMaxQtyStandardCode,
            familyDiscountTarget: selectedGoodDetail?.familyDiscountTarget,
            multiItem: selectedGoodDetail?.multiItem,
            count: 1,
          },
        ]);
      }
    },
    [goodOptionList, optionDropdownValidator, selectedGoodDetail, setGoodOptionList]
  );

  return { selectedGoodDetail, sortedSelectedOptionList, additionItemList, handleDropDownOption };
};

export default useGoodOption;
